var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.2872 7.52197L11.0005 12.3161L2.71387 7.52197C3.08053 6.84363 3.6122 6.2478 4.20803 5.9178L9.10303 3.20447C10.148 2.6178 11.853 2.6178 12.898 3.20447L17.793 5.9178C18.3889 6.2478 18.9205 6.84363 19.2872 7.52197Z",
    fill: "#5B6B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.0006 12.3161V21.0978C10.3131 21.0978 9.62557 20.9511 9.10307 20.6578L4.20807 17.9445C3.09891 17.3303 2.19141 15.7903 2.19141 14.5253V9.33697C2.19141 8.75031 2.39307 8.10864 2.71391 7.52197L11.0006 12.3161Z",
    fill: "#5B6B79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8098 9.33697V14.5253C19.8098 15.7903 18.9023 17.3303 17.7931 17.9445L12.8981 20.6578C12.3756 20.9511 11.6881 21.0978 11.0006 21.0978V12.3161L19.2873 7.52197C19.6081 8.10864 19.8098 8.75031 19.8098 9.33697Z",
    fill: "#5B6B79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.bcd9f078bf8bcc2b1e3df89cdfa165df.svg";
export { ForwardRef as ReactComponent };